import React, {PureComponent} from "react";
import {
  TouchableOpacity
} from "react-native";

export default class TouchableDebounce extends PureComponent {
	constructor(props){
		super(props);
		this.state = {
			clicked: false
		};
		this.handlePress = handlePress.bind(this);
		this.timeout = null;
	}

	componentWillUnmount(){
		clearTimeout(this.timeout);
		this.timeout = null;
	}

	render(){
		return (
			<TouchableOpacity {...this.props} onPress={this.handlePress}>
				{this.props.children}
			</TouchableOpacity>
		);
	}
}

function handlePress(){
	var delayClicks = this.props.delayClicks || 2000;
	if(this.state.clicked) return;
	this.timeout = setTimeout(updateClick.bind(this), delayClicks);
	this.props.onPress();
	this.setState({
		clicked: true
	});
}

function updateClick(){
	this.setState({
		clicked: false
	});
	clearTimeout(this.timeout);
	this.timeout = null;
}